export type AddressValue = {
    addressLine1: string
    addressLine2: string
    postalCode: string
    city: string
    region: string
    countryCode: string | null
}

export const emptyAddress = (): AddressValue => ({
    addressLine1: '',
    addressLine2: '',
    postalCode: '',
    city: '',
    region: '',
    countryCode: null,
})

export const addressSuggestionLabel = (suggestion: AddressValue): string =>
    [suggestion.addressLine1, suggestion.postalCode, suggestion.city].filter(Boolean).join(', ')
